type Format = 'dash' | 'parentheses'

export const formatProductName = (
    productName: string,
    productVariantName: string | null | undefined,
    format: Format = 'dash'
): string => {
    if (!productVariantName) return productName

    if (format === 'parentheses') {
        return `${productName} (${productVariantName})`
    }

    return `${productName} - ${productVariantName}`
}
